const initDropdowns = () => {
    if (document) {
        const triggers = document.getElementsByClassName('js-dropdownTrigger');
        for (let i = 0, len = triggers.length; i < len; i++) {
            const trigger = triggers[i];
            const contentId = trigger.getAttribute('data-contentid');
            const contentEle = document.getElementById(contentId);
            if (contentEle) {
                trigger.addEventListener('click', e => {
                    const eles = [contentEle, trigger];
                    eles.forEach(ele => {
                        if (ele.className.indexOf('menu-isOpen') === -1) {
                            ele.className += ' menu-isOpen';
                        } else {
                            ele.className = ele.className
                                .split('menu-isOpen')
                                .join('')
                                .split('  ')
                                .join(' ');
                        }
                    });

                    e.preventDefault();
                });
            }
        }
    }
};

initDropdowns();
